import http from '@/utils/http.js';
const rootUrl = '/api';

const commonApi = {
	/**
	 * 获取国家码
	 * @returns
	 */
	getCountry() {
		return http.get( `${rootUrl}/fetchCountriesV2`, { errCode: 'commonApi.getCountry' });
	},
	/**
	 *
	 * @returns
	 */
	getSettings( targetData ) {
		return http.post( `${rootUrl}/resourceListV2`, { data: { nameCode: targetData }, errCode: 'commonApi.getSettingList' });
	},
	/**
	 * 获取公告
	 * @returns
	 */
	getAnnouncement( params ) {
		return http.get( `${rootUrl}/fetchAnnouncePushList`, { params, errCode: 'commonApi.getAnnouncement' });
	},
	/**
	 * 获取更新日志详情
	 * @returns
	 */
	getUpdateLogDetail( params ) {
		return http.get( `${rootUrl}/getAnnouncePushInfo`, { params, errCode: 'commonApi.getUpdateLogDetail' });
	},
	/**
	 * 后端登出
	 */
	userLogout( data ) {
		return http.post( '/api/userLogout', { data, errCode: 'commonApi.userLogout' });
	}
};
export default commonApi;
